import { z } from 'zod';
export const getTradingCompetitionOutputSchema = z.object({
    id: z.string(),
    communityId: z.string(),
    startDate: z.string().datetime(),
    endDate: z.string().datetime(),
    frequency: z.string(),
    rewards: z.number(),
    totalRewards: z.number(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
